export const NAME = 'search';
export const LEVEL_ONE = 'SearchComponentReducer';